import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { TaraSurvey } from '../components/features/Tara';
import { actions } from '../actions/tara';
import { getHasAnsweredSurvey } from '../reducers/tara/hasAnsweredSurvey';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getIsFetching } from '../reducers/tara/isFetching';
import { getStatus } from '../reducers/tara/status';
import { getTaraSurvey } from '../reducers/tara/survey';
import { actions as analyticsActions } from '../actions/analytics';

class TaraSurveyContainer extends React.PureComponent {
  state = {
    isViewingSurvey: !this.props.hasAnsweredSurvey,
  };

  hasSubmitted = false;

  componentDidMount() {
    this.props.taraGetSurveyRequest();
  }

  componentWillUnmount() {
  }

  get shouldRenderSurvey() {
    const { isViewingSurvey } = this.state;
    const { survey } = this.props;

    return !!survey && isViewingSurvey;
  }

  setHasMadeIntroduction = () => {
    if (!this.props.hasMadeIntroduction) {
      this.props.taraSetHasMadeIntroduction(true);
    }
  };

  submitForm = (form) => {
    this.setHasMadeIntroduction();

    if (!this.hasSubmitted) {
      this.hasSubmitted = true;
      this.props.taraPostSurveyRequest(form);
    }
  };

  handleCancel = (e, form) => {
    this.setState({ isViewingSurvey: false });
    this.submitForm(form);
    if(this.hasSubmitted)
      this.props.analyticsRecordActionRequest('survey','close', '');
    else
      this.props.analyticsRecordActionRequest('survey','cancel', '');
  };

  handleSubmit = (e, form) => this.submitForm(form);

  render() {
    return (
      <TaraSurvey
        {...this.props}
        isOpen={this.shouldRenderSurvey}
        isAnimated
        onCancel={this.handleCancel}
        onSubmit={this.handleSubmit}
        isFetching={this.props.isFetching}
        status={this.props.status}
      />
    );
  }
}

const getState = (state, ownProps) => ({
  survey: getTaraSurvey(state),
  hasAnsweredSurvey: getHasAnsweredSurvey(state),
  hasMadeIntroduction: getTaraHasMadeIntroduction(state),
  isFetching: getIsFetching(state),
  status: getStatus(state),
  ...ownProps,
});

const getActions = dispatch => bindActionCreators({
  taraSetHasMadeIntroduction: actions.taraSetHasMadeIntroduction,
  taraGetSurveyRequest: actions.taraGetSurveyRequest,
  taraPostSurveyRequest: actions.taraPostSurveyRequest,
  ...analyticsActions,
}, dispatch);

export default connect(getState, getActions)(TaraSurveyContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraSurveyContainer.js